import { ApplicationExceptionHandler } from '@gtpl/shared-utils/error-messages';
import { Body, Controller, Post, Req } from '@nestjs/common';
import { AllRackCellMapsResponseModel, RackCellMapDto, RackCellMapResponseModel } from '@gtpl/shared-models/masters';
import { RackCellMap } from './rack-cell-mapping.entity';
import { RackCellMapAdapter } from './dto/rack-cell-mapping.adapter';
import { RackCellMapDTO } from './dto/rack-cell-mapping.dto';
import { RackCellMapRequest } from './dto/rack-cell-mapping.request';
import { ApiTags } from '@nestjs/swagger';
import { RackCellMappingService } from './rack-cell-mapping.service';

@ApiTags('rack-cell-mapping')
@Controller('rack-cell-mapping')
export class RackCellMappingController {

    constructor(
        private rackCellMapService: RackCellMappingService,
        private readonly applicationExceptionHandler: ApplicationExceptionHandler,
      ) {}

      @Post('/createRackCellMap')
      async createRackCellMap(@Body() rackCellMapDto:RackCellMapDTO,isUpdate:boolean=false,@Req() request:Request): Promise<RackCellMapResponseModel> {
          try {
           return await this.rackCellMapService.createRackCellMap(rackCellMapDto,false,request);
         } catch (error) {
              return this.applicationExceptionHandler.returnException(RackCellMapResponseModel, error);
         }
       }
  /**
   * 
   * @returns 
   */
      
  
      @Post('/getAllRackCellMaps')
      async getAllCells(): Promise<AllRackCellMapsResponseModel> {
          try {
              return await this.rackCellMapService.getAllRackCellMaps();
          } catch (error) {
              return this.applicationExceptionHandler.returnException(AllRackCellMapsResponseModel, error);
          }
      }
      @Post('/getAllActiveRackCellMaps')
  async getAllActiveRackCellMaps(@Req() request: Request): Promise<AllRackCellMapsResponseModel> {
      try {
          return await this.rackCellMapService.getAllActiveRackCellMaps();
      } catch (error) {
          return this.applicationExceptionHandler.returnException(AllRackCellMapsResponseModel, error)
      }
  }
  
       /**
       * Activate Or De-Activate Value RackCellMap
       * @param getSingleRackCellMap RackCellMapResponseModel 
       * @returns Value RackCellMap
       */
     @Post('/activateOrDeactivateRackCellMap')
     async activateOrDeactivateRackCellMap(@Body() rackCellMapReq: RackCellMapRequest): Promise<RackCellMapResponseModel> {
         try {
             return await this.rackCellMapService.activateOrDeactivaterackCellMap(rackCellMapReq);
         } catch (err) {
             return this.applicationExceptionHandler.returnException(RackCellMapResponseModel, err);
         }
     }
  
      /**
       * creates or updates a value of RackCellMap
       * @param RackCellMapDto RackCellMap DTO
       * @returns RackCellMapResponse
       */
       @Post('/updateRackCellMap')
       async updateRackCellMap(@Body() rackCellMapDto:RackCellMapDTO,isUpdate:boolean=true,@Req() request:Request): Promise<RackCellMapResponseModel> {
           try {
            return await this.rackCellMapService.createRackCellMap(rackCellMapDto,true,request);
          } catch (error) {
               return this.applicationExceptionHandler.returnException(RackCellMapResponseModel, error);
          }
        }
}
